import {
  B1,
  B2,
  B5,
  SH1,
  WebDatePicker,
  colors as zetColors,
} from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack } from '@zet/design-system/layout'

const DateSelector = ({
  label,
  onChange,
  onBlur,
  value,
  errors,
  isRequired = true,
}) => {
  return (
    <Stack className="mt-1">
      <B2 className="text-grays-80 mb-1">
        {label}
        {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : <></>}
      </B2>
      <Icon
        type="CalenderOutlined"
        color={zetColors.grays[50]}
        className="absolute mt-6 pl-2 pt-1"
        size={36}
      ></Icon>

      <WebDatePicker
        onChange={(v) => {
          onChange(v?.target?.value)
        }}
        onBlur={onBlur}
        value={value}
        style={{
          // Desktop browsers render their own dd/mm/yyyy hint inside an empty
          // date input; make it transparent so only our overlay shows.
          color: value ? '#2F3440' : 'transparent',
          paddingLeft: 42,
        }}
      />
      {/* The bare date input renders empty until a value is picked, so paint
          the placeholder ourselves; pointerEvents none keeps taps reaching
          the input underneath. */}
      {!value && (
        <Stack
          className="absolute left-3 ml-4 mt-6 pt-1"
          pointerEvents="none"
        >
          <SH1 className="text-grays-50">DD/MM/YYYY</SH1>
        </Stack>
      )}
      {errors?.name?.message ? (
        <Stack className="mt-2">
          <B5 className="text-error-100">{errors?.name?.message}</B5>
        </Stack>
      ) : null}
    </Stack>
  )
}

export default DateSelector
